import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, CircularProgress, DialogActions, IconButton} from "@mui/material";
import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import BBIconEdit from "../../../../assets/bbCustomIcons/BBIconEdit";
import {BRCustomizedTooltip} from "../../accents/BRCustomizedTooltip";
import {updateCustomerName} from "../../../../actions";

const UpdateCustomerNameDialog =({children=null, customerId=null,  })=>{

    const { loadingUpdateCustomerName, loadingUpdateCustomerNameError, loadingCustomers ,customers } = useSelector(({customer})=> customer)
    const dispatch = useDispatch();

    const customer = customers && customerId ? customers[customerId] : null;
    const customerName = customer && customer.CustomerName ? customer.CustomerName : null;

    const [open, setOpen] = useState(false);
    const [newValue, setNewValue] = useState(null);

    const handleSubmit = ()=>{
        console.log("Submitting these values", customerId, newValue)
        dispatch(updateCustomerName(customerId, newValue));
        setOpen(false);
    }


    return(
        <div>
            {!loadingUpdateCustomerName[customerId]
                ? <span className={"m-0 p-0 d-inline"}>
                    {children ? children : "--"}&nbsp;
                    <BRCustomizedTooltip title={"Click to Edit"}>
                        <IconButton onClick={()=>setOpen(true)} className={"mx-1 my-0 p-0 d-inline"}>
                            <BBIconEdit style={{fontSize: "1rem"}} />
                        </IconButton>
                    </BRCustomizedTooltip>
                </span>
                : <CircularProgress/>}


            {open &&
                <Dialog open={open}
                        fullScreen={false}
                        fullWidth={true}
                        maxWidth={"sm"}
                        className={"m-1 p-1 animated fadeIn animation-duration-6"}
                        aria-labelledby="form-dialog-title">

                    <DialogTitle id="customized-dialog-title" >
                        <Row>
                            <Col lg={11}/>
                            <Col lg={1} className={"text-right align-self-center d-print-none"}>
                                <IconButton
                                    onClick={()=>setOpen(false)}
                                    className={"close"}>
                                    <CloseIcon/>
                                </IconButton>
                            </Col>
                        </Row>
                    </DialogTitle>
                    <DialogContent>

                        <label htmlFor={"customerName"}>
                            <h4>Update Company Name:</h4>
                        </label>
                        <input
                            id={"customerName"}
                            type={"text"}
                            name={"customerName"}
                            defaultValue={customerId  ? customer.CustomerName : ""}
                            onChange={(e)=>setNewValue(e.target.value)}
                            className="mt-1 p-2 my-sm-3 form-control"/>

                    </DialogContent>

                    <DialogActions>
                        <Col lg={12}>

                            <Button onClick={()=>setOpen(false)}
                                    variant="contained" color="primary"
                                    style={{float: "right"}}>
                                Cancel
                            </Button>
                            <Button
                                className={"float-right"}
                                variant="contained" color="primary"
                                type={"submit"}
                                onClick={()=>handleSubmit()}
                            >
                                Submit
                            </Button>
                        </Col>
                    </DialogActions>
                </Dialog>
            }
        </div>
    )
}

export default UpdateCustomerNameDialog;